import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../base/api.service';

@Injectable({
  providedIn: 'root',
})
export class SavedSearchService extends ApiService {
  savedSearches(request: any): Observable<any> {
    return this.post(`/platform/api/orders/saved-list`, request);
  }

  preorder(request: any): Observable<any> {
    return this.post(`/platform/api/orders/pre-order`, request);
  }

  finalizeOrder(request: any): Observable<any> {
    return this.post(`/platform/api/orders/finalize`, request);
  }

  getOrderReview(searchId: any): Observable<any> {
    return this.get(`/platform/api/orders/${searchId}/review`);
  }

  getPdfFile(searchId: any): Observable<any> {
    return this.getFile(`/platform/api/orders/${searchId}/support-file`);
  }

  fileUpload(formData: any): Observable<any> {
    return this.post('/platform/api/storages/file-upload', formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  generateFile(searchId: any): Observable<any> {
    return this.getFile(`/platform/api/report/${searchId}/generate`);
  }

  downloadFile(searchId: any): Observable<any> {
    return this.getZipFile(`/platform/api/report/${searchId}/download`);
  }
}
